import { styled } from '../../styled';
export var SelectMenuBody = styled('div', { name: 'QuantumSelectMenuBody' })({
    maxHeight: 400,
    minHeight: 260,
    overflowX: 'hidden',
    overflowY: 'auto',
});
